/**
 * Auth Layout Route
 *
 * Layout for authentication pages (sign-in, sign-up).
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Zap } from 'lucide-react';

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Header */}
      <header className="flex h-16 items-center justify-center border-b border-default-100">
        <a href="/" className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-foreground">
            <Zap className="h-4 w-4 text-background" />
          </div>
          <span className="text-lg font-semibold tracking-tight text-foreground">Relay</span>
        </a>
      </header>

      {/* Centered content */}
      <main className="flex flex-1 items-center justify-center p-4">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="flex h-16 items-center justify-center border-t border-default-100 text-sm text-default-500">
        <p>Relay - Voice AI Artifact Detection</p>
      </footer>
    </div>
  );
}
